module.exports = __webpack_public_path__ + "media/images/sports_icons/baseball-bat-886b74e24ebffdf1b68d2c034d80244d.png";